const initialState = {
  admin: null,
  loading: false,
  locationSettings: null,
  manager: null,
  user: null,
};

export default initialState;
